"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { SessionContent } from "./use-session-content";

const INERT: SessionContent = {
  slots: null,
  visitors: null,
  blocked: null,
  settled: true,
  refresh: () => {},
};

const SessionContentContext = createContext<SessionContent>(INERT);

/** Provides the visitor's session content to the tabs. `value` must be memoised by the caller. */
export function SessionContentProvider({
  value,
  children,
}: {
  value: SessionContent;
  children: ReactNode;
}) {
  return <SessionContentContext.Provider value={value}>{children}</SessionContentContext.Provider>;
}

/** Inert (public projection, nothing to wait for) when no provider is mounted (demo / tests). */
export function useSessionContentContext(): SessionContent {
  return useContext(SessionContentContext);
}
